<template>
  <div :class="classes">
    <!--input goes here -->
    <slot></slot>
    <div v-if="props.show || props.enhancedCartShow" :class="{ 'icon-text-sidebyside': props.showIcon }">
      <slot v-if="props.showIcon" name="icon">
        <svg-icon-component icon="circle-exclamation" />
      </slot>
      <slot name="error">Error</slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import SvgIconComponent from "@/components/shared/SvgIcon/SvgIcon.vue";

const props = defineProps({
  show: {
    type: Boolean,
    required: false,
    default: false,
  },
  danger: {
    type: Boolean,
    required: false,
    default: true,
  },
  enhancedCartShow: {
    type: Boolean,
    default: false,
  },
  showIcon: {
    type: Boolean,
    default: true,
  },
});

const classes = computed(() => {
  return {
    "validation": props.show,
    "danger": props.danger,
    "zuora-validation": props.enhancedCartShow,
    "zuora-icon-validation": props.showIcon,
  };
});
</script>
